import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { usePartial } from 'shared/hooks/utils';
import { EventItem } from '../event-item';
import * as S from './styles';
import { eventsStateFiltered } from 'console/tabs/events/utils';
export const EventBatchElement = memo(function EventBatchImpl(props) {
    const { events, device_id, event_filter, show_network_events } = props;
    const filterFunc = usePartial(eventsStateFiltered, event_filter, show_network_events);
    return (_jsx(S.EventBatch, { children: events.filter(filterFunc).map((event, index) => (_jsx(EventItem, { loc_event: event, device_id: device_id }, index))) }));
});
